import Container from '../../shared/components/Container/Container';
import Section from '../../shared/components/Section/Section';

export default function WhoIsItFor() {
  return (
    <Section>
      <Container>
        <h1>WhoIsItFor</h1>
      </Container>
    </Section>
  );
}
